import { Checkbox as DigdirCheckbox, useCheckboxGroup, } from "@digdir/designsystemet-react";
const Checkbox = DigdirCheckbox;
Checkbox.displayName = "Checkbox";
export { Checkbox, useCheckboxGroup, };
//# sourceMappingURL=checkbox.js.map